"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.validationSchema = (0, yup_1.object)().shape({
    title: yup_rules_1.titleValidationSchema,
    productId: yup_rules_1.dbIdValidationSchema,
    imageUrl: yup_rules_1.urlValidationSchema,
});
//# sourceMappingURL=validation.js.map